import PropTypes from "prop-types";

function Button({
  children,
  type = "button",
  variant = "primary",
  disabled = false,
  onClick,
}) {
  const baseStyles =
    "px-4 py-2 rounded font-medium focus:outline-none focus:ring-2 focus:ring-offset-2";
  const variantStyles = {
    primary: "bg-[#2C4E86] text-white hover:bg-blue-900 focus:ring-blue-500",
    secondary:
      "bg-gray-300 text-gray-700 hover:bg-gray-400 focus:ring-gray-500",
  };

  return (
    <button
      type={type}
      className={`${baseStyles} ${variantStyles[variant]} ${
        disabled ? "opacity-50 cursor-not-allowed" : ""
      }`}
      disabled={disabled}
      onClick={onClick}
    >
      {children}
    </button>
  );
}

Button.propTypes = {
  children: PropTypes.node.isRequired,
  type: PropTypes.string,
  variant: PropTypes.oneOf(["primary", "secondary"]),
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
};

export default Button;
